import React from "react";

// fetchPayment.js - API functions for payment management

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    throw new Error('No authentication token found');
  }

  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

// Add payment vaad
export const addPaymentVaad = async (paymentData) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/addVaadPayment`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(paymentData)
    });


    if (!response.ok) {
      // Try to get error message from response
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Add payment failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Check for existing one-time payments for an apartment
export const checkOneTimePayment = async (buildingId, apartmentNumber) => {
  try {
    const response = await fetch(`${API_URL}/api/payment/check-one-time-payment/${buildingId}/${apartmentNumber}`, {
      method: 'GET',
      headers: getAuthHeaders()
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Check one-time payment failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Update Payment
export const UpdatePaymentVaad = async (paymentData) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/UpdateVaadPayment`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(paymentData)
    });


    if (!response.ok) {
      // Try to get error message from response
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Update payment failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Get list payments
export const getListPaymentsByBuildingId = async (buildingId) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/getListPaymentsByBuildingId`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(buildingId)
    });


    if (!response.ok) {
      // Try to get error message from response
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Get payments failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Get VaadMonthly data by building ID
export const getListVaadMonthlyByBuildingId = async (buildingId) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/getListVaadMonthlyByBuildingId`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(buildingId)
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Get VaadMonthly data failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Get simple VaadMonthly data (just apartment number and amount)
export const getVaadMonthlySimple = async (buildingId) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/getVaadMonthlySimple`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(buildingId)
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Get simple VaadMonthly data failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Delete payment
export const deletePaymentVaad = async (paymentId) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/DeleteVaadPayment/${paymentId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Delete payment failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Generate secure download link for payment email file
export const generateDownloadLink = async (paymentId) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/generate-download-link`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ PaymentId: paymentId })
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Generate download link failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Generate payment summary for multiple payments (NEW - Short URL solution)
export const generatePaymentSummary = async (paymentIds, tenantName, apartmentNumber) => {
  try {
    const response = await fetch(`${API_URL}/api/payment/generate-payment-summary`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ 
        PaymentIds: paymentIds,
        TenantName: tenantName,
        ApartmentNumber: apartmentNumber
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Generate payment summary failed`);
    }

    const result = await response.json();
    
    if (result.success) {
      console.log(`✅ Payment summary generated successfully!`);
      console.log(`📊 ${result.paymentCount} payments, Total: ₪${result.totalAmount}`);
      console.log(`📏 URL length: ${result.urlLength} characters (${result.urlLength < 150 ? 'PERFECT' : result.urlLength < 200 ? 'GOOD' : 'LONG'})`);
      console.log(`🔗 Summary URL: ${result.summaryUrl}`);
    }

    return result;
  } catch (err) {
    console.error('❌ Error generating payment summary:', err);
    throw err;
  }
};

// Generate WhatsApp message with download link
export const generateWhatsAppMessage = async (paymentId) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/generate-whatsapp-message`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ PaymentId: paymentId })
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Generate WhatsApp message failed`);
    }

    const result = await response.json();

    // Enhanced logging for Option 2 URLs
    if (result.success) {
      
      if (result.downloadUrl) {
        const urlLength = result.downloadUrl.length;
        
        // ✅ Check Option 2 results
        if (urlLength <= 150) {
        } else if (urlLength <= 200) {
        } else if (urlLength <= 300) {
        } else {
        }
        
        // Show token extraction for debugging
        try {
          const url = new URL(result.downloadUrl);
          const token = url.pathname.split('/').pop();
        } catch (urlError) {
        }
        
      } else {
      }
      
      
      // Include URL length in result for frontend
      if (result.downloadUrl) {
        result.downloadUrlLength = result.downloadUrl.length;
        result.isOption2Optimal = result.downloadUrl.length <= 150;
      }
      
    } else {
    }

    return result;
  } catch (err) {
    throw err;
  }
};

// Get payment details for WhatsApp sharing
export const getPaymentForWhatsApp = async (paymentId) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/get-payment-details/${paymentId}`, {
      method: 'GET',
      headers: getAuthHeaders()
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Get payment details failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Send payment reminder email
export const sendPaymentReminder = async (reminderData) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/send-payment-reminder`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(reminderData)
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Send payment reminder failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Notify bank transfer
export const notifyBankTransfer = async (transferData) => {
  try {

    const response = await fetch(`${API_URL}/api/payment/notify-bank-transfer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(transferData)
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Notify bank transfer failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// DEBUG FUNCTION - Test WhatsApp message generation
// Usage: testWhatsAppGeneration(123) where 123 is a valid payment ID
export const testWhatsAppGeneration = async (paymentId) => {
  try {

    if (!paymentId || paymentId <= 0) {
      return { error: 'Invalid payment ID' };
    }

    // Test the API call
    const result = await generateWhatsAppMessage(paymentId);


    if (result.success) {

      if (result.hasDownloadLink && result.downloadUrl) {

        // Test if the download link is accessible (optional)
        try {
          const testResponse = await fetch(result.downloadUrl, { method: 'HEAD' });
        } catch (testError) {
        }
      } else {
      }
    } else {
    }

    return result;
  } catch (error) {
    return { error: error.message };
  }
};

// DEBUG FUNCTION - Test download link generation directly
export const testDownloadLinkGeneration = async (paymentId) => {
  try {

    if (!paymentId || paymentId <= 0) {
      return { error: 'Invalid payment ID' };
    }

    const result = await generateDownloadLink(paymentId);


    if (result.success) {
    } else {
    }

    return result;
  } catch (error) {
    return { error: error.message };
  }
};

// DEBUG FUNCTION - Get payment details for debugging
export const debugPaymentDetails = async (paymentId) => {
  try {

    const result = await getPaymentForWhatsApp(paymentId);


    if (result.success && result.payment) {
      const payment = result.payment;
    } else {
    }

    return result;
  } catch (error) {
    return { error: error.message };
  }
};

// Utility function to format money amounts
export const formatAmount = (amount) => {
  return new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: 'ILS'
  }).format(amount);
};

// Utility function to format dates in Hebrew
export const formatDateHebrew = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('he-IL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// Utility function to get month names in Hebrew
export const getMonthNameHebrew = (monthNumber) => {
  const monthNames = {
    1: 'ינואר', 2: 'פברואר', 3: 'מרץ', 4: 'אפריל',
    5: 'מאי', 6: 'יוני', 7: 'יולי', 8: 'אוגוסט',
    9: 'ספטמבר', 10: 'אוקטובר', 11: 'נובמבר', 12: 'דצמבר'
  };
  return monthNames[monthNumber] || monthNumber.toString();
};

// Export all debug functions for console access
export const debugFunctions = {
  testWhatsAppGeneration,
  testDownloadLinkGeneration,
  debugPaymentDetails
};

// Make debug functions available in development mode
if (process.env.NODE_ENV === 'development') {
  window.paymentDebug = debugFunctions;
}


export const testDownloadUrl = (url) => {

  // Just validate structure, don't make network requests
  const validation = validateDownloadUrl(url);
  
  if (!validation.valid) {
    return Promise.resolve({
      success: false,
      error: validation.error,
      url: url,
      urlLength: url.length
    });
  }

  if (validation.warning) {
  }

  
  return Promise.resolve({
    success: true,
    message: validation.message || 'URL structure validated successfully',
    url: url,
    urlLength: url.length,
    note: 'Network test skipped to avoid CORS issues - URL should work when clicked'
  });
};


// ✅ Format payment messages for better WhatsApp display
const formatPaymentMessage = (message) => {
  try {
    
    // If message is one long line, try to split by common patterns
    let processedMessage = message;
    if (!message.includes('\n') && message.length > 100) {
      // Split by Hebrew field patterns
      processedMessage = message
        .replace(/(שם:)/g, '\n$1')
        .replace(/(תקופת תשלום:)/g, '\n$1')
        .replace(/(סכום:)/g, '\n$1')
        .replace(/(דירה:)/g, '\n$1')
        .replace(/(סוג תשלום:)/g, '\n$1')
        .replace(/(אמצעי תשלום:)/g, '\n$1')
        .replace(/(מספר אסמכתא:)/g, '\n$1')
        .replace(/(הורד קבלה:)/g, '\n$1')
        .replace(/(תודה על התשלום)/g, '\n$1');
    }
    
    // Split the message into lines and clean each line
    let lines = processedMessage.split('\n').map(line => line.trim()).filter(line => line.length > 0);
    
    // Find the title line
    const titleLine = lines.find(line => line.includes('אישור תשלום'));
    let formattedMessage = '';
    
    if (titleLine) {
      formattedMessage += `🧾 ${titleLine}\n`;
      formattedMessage += '━━━━━━━━━━━━━━━━━━━━━━\n\n';
    }
    
    // Process other lines and add appropriate formatting
    lines.forEach(line => {
      if (line.includes('אישור תשלום')) return; // Skip title, already added
      
      if (line.includes('שם:')) {
        formattedMessage += `👤 ${line}\n`;
      } else if (line.includes('תקופת תשלום:')) {
        formattedMessage += `📅 ${line}\n`;
      } else if (line.includes('סכום:')) {
        formattedMessage += `💰 ${line}\n`;
      } else if (line.includes('דירה:')) {
        formattedMessage += `🏠 ${line}\n`;
      } else if (line.includes('סוג תשלום:')) {
        formattedMessage += `📋 ${line}\n`;
      } else if (line.includes('אמצעי תשלום:')) {
        formattedMessage += `💳 ${line}\n`;
      } else if (line.includes('מספר אסמכתא:')) {
        formattedMessage += `🔢 ${line}\n\n`;
      } else if (line.includes('הורד קבלה:')) {
        formattedMessage += `📥 ${line}\n\n`;
      } else if (line.includes('תודה על התשלום')) {
        formattedMessage += `✅ ${line}\n`;
      } else if (line.trim().length > 0) {
        // Add bullet point if line doesn't start with emoji
        if (!line.match(/^[🧾👤📅💰🏠📋💳🔢📥✅]/)) {
          formattedMessage += `• ${line}\n`;
        } else {
          formattedMessage += `${line}\n`;
        }
      }
    });
    
    // Clean up extra newlines
    formattedMessage = formattedMessage.replace(/\n{3,}/g, '\n\n').trim();
    
    return formattedMessage;
    
  } catch (error) {
    return message;
  }
};

export const validateDownloadUrl = (url) => {
  try {
    // Basic URL validation
    const urlObj = new URL(url);
    
    // Check if it's the expected download endpoint
    if (!urlObj.pathname.includes('/api/payment/download/')) {
      return {
        valid: false,
        error: 'URL is not a payment download endpoint'
      };
    }
    
    // ✅ With Option 2, URLs should be very short now
    if (url.length > 200) {
      return {
        valid: true,
        warning: `URL longer than expected (${url.length} characters)`
      };
    }
    
    // Check for suspicious characters
    const suspiciousChars = /[<>"\s{}`|\\^]/;
    if (suspiciousChars.test(url)) {
      return {
        valid: false,
        error: 'URL contains potentially problematic characters'
      };
    }
    
    return { 
      valid: true, 
      message: `Perfect URL length with Option 2: ${url.length} characters` 
    };
    
  } catch (error) {
    return {
      valid: false,
      error: 'Invalid URL format'
    };
  }
};


export const openWhatsAppSafely = (message, phoneNumber = null) => {
  try {
    
    // Simple cleaning - just fix the replacement characters and encode properly
    let cleanMessage = message || 'הודעת תשלום מהמערכת';
    
    // Only fix the encoding issue that was causing problems
    cleanMessage = cleanMessage
      .replace(/\uFFFD/g, '• ') // Replace replacement characters with bullet points
      .replace(/�/g, '• ') // Replace visual replacement character with bullet points  
      .replace(/%EF%BF%BD/gi, '• ') // Replace URL-encoded replacement characters with bullet points
      .trim();
    
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(cleanMessage);
    
    // Create WhatsApp URL (use api.whatsapp.com for direct send)
    let whatsappUrl;
    if (phoneNumber) {
      const cleanPhone = phoneNumber.replace(/\D/g, '');
      whatsappUrl = `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodedMessage}`;
    } else {
      whatsappUrl = `https://api.whatsapp.com/send?text=${encodedMessage}`;
    }
    
    
    // Open WhatsApp Web
    const newWindow = window.open(whatsappUrl, '_blank');
    
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      window.location.href = whatsappUrl;
      return true;
    }
    
    return newWindow;
  } catch (error) {
    return null;
  }
};


export const getUsersForExcelUpload = async (buildingId) => {
  try {
    const response = await fetch(`${API_URL}/api/payment/getUsersForExcelUpload`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(buildingId)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: Get users failed`);
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

// Create multiple payments from Excel upload
export const createPaymentsFromExcel = async (paymentsData) => {
  try {
    const response = await fetch(`${API_URL}/api/Payment/CreatePaymentsFromExcel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paymentsData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Server error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating payments from Excel:', error);
    throw error;
  }
};

// Validate Excel payments data
export const validateExcelPaymentsData = (paymentsData) => {
  const errors = [];
  
  if (!paymentsData || !Array.isArray(paymentsData)) {
    return { isValid: false, errors: ['Invalid data format'] };
  }

  paymentsData.forEach((payment, index) => {
    const rowNum = payment._originalRowNumber || index + 1;
    
    // Check required fields
    if (!payment.UserId) {
      errors.push(`שורה ${rowNum}: משתמש לא נמצא`);
    }
    
    if (!payment.PaymentType) {
      errors.push(`שורה ${rowNum}: סוג תשלום חסר`);
    }
    
    if (!payment.Amount || payment.Amount <= 0) {
      errors.push(`שורה ${rowNum}: סכום לא תקין`);
    }
    
    if (!payment.BuildingId) {
      errors.push(`שורה ${rowNum}: מזהה בניין חסר`);
    }
  });

  return {
    isValid: errors.length === 0,
    errors
  };
};

